import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { applyPreset } from 'src/core/config/env-config';
import { HelpersService } from 'src/core/services/helpers.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Open Fiber | Landing';

  constructor(private helpersService: HelpersService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.helpersService.startRefreshInterval();
    let intervalCdr = setInterval(()=>{
      this.cdr.detectChanges();
    },500)
  }
}
